export const ACCOUNT = '/account';
export const COOKBOOKS = '/cookbooks';
export const HOME = '/';
export const LOG_IN = '/log-in';
export const PASSWORD_FORGET = '/password-forgot';
export const SAVED = '/saved';
export const SIGN_UP = '/sign-up';
export const TERMS_OF_USE = '/terms';
